import { render, staticRenderFns } from "./addLevel.vue?vue&type=template&id=09239f3c&"
import script from "./addLevel.vue?vue&type=script&lang=js&"
export * from "./addLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports